import PageHeader from "./page-header.component";

export default angular
    .module("oui.page-header", [])
    .component("ouiPageHeader", PageHeader)
    .name;
